import { Box, ScrollArea, Text } from "@salestrak/ui";

import { formatDate } from "#app/lib/utils/format-date";
import { PageHeader, PageHeaderBack, PageHeaderSubtitle, PageHeaderTitle } from "#app/components/page-header";
import { ApiKeyActionsMenu } from "./api-key-actions-menu";
import { PermissionBadges, type Permissions } from "./permission-badge";
import { SettingsGroup, SettingsGroupRow } from "./settings-group";
import type { Omittable } from "@salestrak/ui";

type ApiKeyDetailViewProps = Omittable<{
  apiKey: {
    apiKeyId: string;
    name: string;
    permissions: Permissions;
    creationDate?: string | null;
  };
  onBack: () => void;
  onEdit: () => void;
  onRevoke: () => void;
}>;

export function ApiKeyDetailView({
  apiKey,
  onBack,
  onEdit,
  onRevoke,
}: ApiKeyDetailViewProps) {
  const dateLabel = apiKey.creationDate ? formatDate(apiKey.creationDate) : null;

  return (
    <Box direction="column" fill="flex">
      <ScrollArea>
        <PageHeader centered>
          <PageHeaderBack label="API" onClick={onBack} />
          <PageHeaderTitle adornment={<ApiKeyActionsMenu onEdit={onEdit} onRevoke={onRevoke} />}>
            {apiKey.name}
          </PageHeaderTitle>
          {dateLabel ? (
            <PageHeaderSubtitle>Created {dateLabel}</PageHeaderSubtitle>
          ) : null}
        </PageHeader>
        <Box align="center" direction="column" paddingX="md" paddingY="md">
          <Box direction="column" fill="width" maxWidth={800}>
            <SettingsGroup label="Details">
              <SettingsGroupRow label="Key name">
                <Text size="sm" variant="muted">{apiKey.name}</Text>
              </SettingsGroupRow>
              <SettingsGroupRow label="Permissions">
                <PermissionBadges permissions={apiKey.permissions} />
              </SettingsGroupRow>
            </SettingsGroup>
          </Box>
        </Box>
      </ScrollArea>
    </Box>
  );
}
